// extracted by mini-css-extract-plugin
module.exports = {"partnerListItemWrapper":"_381Z1","partnerListItem":"i1MAq","partnerListItemDescription":"_2Z99W","descriptionTextWrapper":"_20vkd","partnerMaskWrapper":"KtGx1"};